/* unplugin-vue-components disabled */import { render } from "./warning.vue?vue&type=template&id=57b3304e&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import "./warning.vue?vue&type=style&index=0&id=57b3304e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b3304e"]])

export default __exports__